import { gql } from '@apollo/client';

export const GET_LIST_TICKETS = gql`
query Filterlisttickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%") {
  filterlisttickets(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null}, 
    where: {
      tp_status: { _eq: "List" },
       tp_is_published: { _eq: true },
       u_pricing_mode: { _ilike: $pricingMode }    
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    }, 
    limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null}, 
    where: {
      tp_status: { _eq: "List" },
       tp_is_published: { _eq: true },
       u_pricing_mode: { _ilike: $pricingMode }    
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    }) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticket_status:null, day:null, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid}, 
    where: {
      tp_is_published: { _eq: false },
      tp_status: { _in: ["ToBeVerified", "Verified"] },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [{ _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }, { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }]
    }) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null}, 
    where: {
      tp_is_published: { _eq: true },
      tp_status: { _eq: "Sold" },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    }) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid}, 
    where: {
      tp_status: { _in: ["Delist", "DelistInProgress", "DelistRequested", "Return"] },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    }) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid}, 
    where: {
      tp_status: { _in: ["Unsold"] },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    }) {
    aggregate {
      count
    }
  }
}
`;

export const GET_MANAGE_TICKETS = gql`
query Filtermanagetickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%") {
  filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    tp_list_price
    u_id
    u_first_name
    u_last_name

    tp_validity_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    user {
      u_role
    }
    full_name
    u_email_id
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"List"}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_SOLD_TICKETS = gql`
query FilterSoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $paymentStatus: String, $payoutType: String = null, $pricingMode: String = "%") {
  FilterSoldTickets: filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_logitix_amount
    tp_sold_amount
    tp_payment_status
    tp_list_price
    tp_quick_cut_amount
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_payout_status
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:null}, where: {_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"List"}}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_DELIST_AND_RETURN_TICKETS = gql`
query Filterreturntickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%") {
  filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
    u_pricing_mode
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_status:{_eq:"List"},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LISTING_REQUEST_CANCELLED_TICKETS = gql`
query FilterListingRequestCancelledTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%") {
  filterListingRequestCancelledTickets: filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
    u_pricing_mode
  }
  filterListingRequestCancelledTickets_aggregate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,payment_status:null}, where: {tp_status:{_eq:"List"},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,payment_status:null}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_DELIST_AND_UNSOLD_TICKETS = gql`
query FilterUnsoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%") {
  filterUnsoldTickets: filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }) {
        n_type
        n_content
      }
    }
    u_pricing_mode
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_status:{_eq:"List"},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LEAGUES_LIST = gql`
query LeaguesDropdownFilter {
  leagues(where: {l_deleted_at: {_is_null: true}}) {
    l_id
    l_name
  }
}
`;

export const VALIDATE_UPDATE = gql`
  mutation UpdateTicketStatus ($isValid: Boolean, $ticketPlacementId: [uuid!]!, $isUndoRequest: Boolean) {
    updateTicketStatus(ticketPlacementId: $ticketPlacementId, isValid: $isValid, isUndoRequest: $isUndoRequest) {
      message
    }
  }
`;



export const PUBLISH_TICKETS = gql`
mutation publishTickets($publishTicketsInput: PublishTicketsInput!) {
  publishTickets(publishTicketInput: $publishTicketsInput) {
    message
  }
}
`;

export const RETURN_TICKET = gql`
mutation UpdateReturnTickets ($ticketPlacementId: [String!]!) {
  returnTickets(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`;

export const UNDO_DELIST_REQUEST_TO_LIST = gql`
  mutation UndoDelistRequestToList($tpId: uuid!) {
    undoDelistRequestToList(tpId: $tpId) {
      message
    }
  }
`;

export const UPDATE_TICKET_DETAILS = gql`
  mutation UpdateTicketDetails($editTicketsInput: EditTicketsInput!) {
    editTickets(editTicketsInput: $editTicketsInput) {
      message
      requiresConfirmation
    }
  }
`;

export const UPDATE_TICKET_DETAILS_DIRECT = gql`
mutation UpdateTicketDetailsDirect($tp_id: uuid!, $section: String, $row: String, $seatNumbers: Int) {
  update_ticket_placement(
    where: { tp_id: { _eq: $tp_id } }
    _set: {
      tp_section: $section
      tp_row: $row
      tp_seat_no: $seatNumbers
    }
  ) {
    returning {
      tp_id
      tp_section
      tp_row
      tp_seat_no
    }
  }
}
`;
// Tracking queries
export const GET_TRACKING_COUNTS = gql`
  query GetTrackingCounts {
    listingExpired: tickets_aggregate(where: { 
      tp_status: { _eq: "ListingRequestExpired" } 
    }) {
      aggregate {
        count
      }
    }
    failedTransfer: tickets_aggregate(where: { 
      tp_status: { _eq: "ToBeVerified" }
    }) {
      aggregate {
        count
      }
    }
  }
`;



// In TicketsQuery.ts - UPDATE THIS MUTATION
export const UPDATE_TICKET_STATUS = gql`
  mutation UpdateTicketStatus($tp_id: uuid, $status: ticket_placement_status_type_enum!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: { tp_status: $status }
    ) {
      returning {
        tp_id
        tp_status
      }
    }
  }
`;

export const UPDATE_TICKET_PAYMENT_STATUS = gql`
  mutation UpdateTicketPaymentStatus($tp_id: uuid!, $set: ticket_placement_set_input!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id }, tp_status: { _eq: Sold } }
      _set: $set
    ) {
      returning {
        tp_id
        tp_status
        tp_payment_status
      }
    }
  }
`;

export const UPDATE_TICKETS_PAYMENT_STATUS = gql`
  mutation UpdateTicketsPaymentStatus($tp_ids: [uuid!]!, $set: ticket_placement_set_input!) {
    update_ticket_placement(
      where: { tp_id: { _in: $tp_ids }, tp_status: { _eq: Sold } }
      _set: $set
    ) {
      affected_rows
      returning {
        tp_id
        tp_status
        tp_payment_status
      }
    }
  }
`;

export const RESTORE_CANCELLED_LISTING_TO_VERIFICATION = gql`
  mutation RestoreCancelledListingToVerification($tp_id: uuid!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: { tp_status: ToBeVerified, tp_delist_requested_email: null }
    ) {
      returning {
        tp_id
        tp_status
      }
    }
  }
`;

export const GET_TICKETS_TO_AUTO_EXPIRE = gql`
  query GetTicketsToAutoExpire($pricingMode: String = "%") {
    filtermanagetickets(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:null, day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        _and: [
          {tp_is_published:{_eq:false}},
          {tp_status:{_in:["ToBeVerified","Verified"]}},
          {u_pricing_mode:{_ilike:$pricingMode}}
        ]
      }
      limit: 5000
    ) {
      tp_id
      e_date
      e_date_time_zone
    }
    ticket_placement(
      where: {
        _and: [
          {tp_is_published:{_eq:false}},
          {tp_status:{_in:[ToBeVerified, Verified]}},
          {tp_deleted_at:{_is_null:true}},
          {ticket:{t_deleted_at:{_is_null:true}}}
        ]
      }
      limit: 5000
    ) {
      tp_id
      ticket {
        event {
          e_date
          e_date_time_zone
        }
      }
    }
  }
`;

export const BULK_EXPIRE_TICKETS = gql`
  mutation BulkExpireTickets($tp_ids: [uuid!]!) {
    update_ticket_placement(
      where: {
        tp_id: { _in: $tp_ids }
        tp_is_published: { _eq: false }
        tp_status: { _in: [ToBeVerified, Verified] }
      }
      _set: { tp_status: Closed }
    ) {
      affected_rows
      returning {
        tp_id
      }
    }
  }
`;


// Update these queries in your TicketsQuery.ts file

export const GET_EXPIRED_TICKETS = gql`
  query GetExpiredTickets($pageSize: Int = 5000, $pageOffset: Int = 0, $search_event: String = "%", $search_client: String = "%", $order_by: [getmanageticket_order_by!]) {
    filterreturntickets(
      args: {enddate:null, leagueid:null, startdate:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_status: {_eq: "Closed"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
      limit: $pageSize
      offset: $pageOffset
      order_by: $order_by
    ) {
      e_name
      l_name
      e_date
      e_address
      tp_section
      tp_row
      tp_seat_no
      u_id
      u_first_name
      u_last_name
      u_pricing_mode
      e_id
      t_id
      tp_id
      u_full_name: full_name
      u_email_id
      tp_list_price
      tp_status
      u_original_email
      e_brand_name
      e_status
      e_time_zone
      e_date_time_zone
      tp_delist_requested_email
      tp_updated_at
      tp_is_support_vanderbilt_nil_fund
      u_pricing_mode
    }
    filterreturntickets_aggregate(
      args: {enddate:null, leagueid:null, startdate:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_status: {_eq: "Closed"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    closed_placement_aggregate: ticket_placement_aggregate(
      where: {
        tp_status: { _eq: Closed }
        tp_deleted_at: { _is_null: true }
        _and: [
          {
            _or: [
              { ticket: { event: { e_name: { _ilike: $search_event } } } },
              { ticket: { event: { e_address: { _ilike: $search_event } } } }
            ]
          },
          {
            _or: [
              { ticket: { user: { u_first_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_last_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
              { ticket: { user: { u_original_email: { _ilike: $search_client } } } }
            ]
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    closed_orphan_placements: ticket_placement(
      where: {
        tp_status: { _eq: Closed }
        tp_deleted_at: { _is_null: true }
        _and: [
          {
            _or: [
              { ticket: { event: { e_name: { _ilike: $search_event } } } },
              { ticket: { event: { e_address: { _ilike: $search_event } } } }
            ]
          },
          {
            _or: [
              { ticket: { user: { u_first_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_last_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
              { ticket: { user: { u_original_email: { _ilike: $search_client } } } }
            ]
          }
        ]
      }
      limit: $pageSize
      offset: $pageOffset
    ) {
      tp_id
      t_id
      tp_section
      tp_row
      tp_seat_no
      tp_list_price
      tp_status
      tp_updated_at
      tp_delist_requested_email
      tp_is_support_vanderbilt_nil_fund
      ticket {
        u_id
        event {
          e_id
          e_name
          e_date
          e_address
          e_brand_name
          e_status
          e_time_zone
          e_date_time_zone
        }
        user {
          u_id
          u_first_name
          u_last_name
          u_email_id
          u_original_email
          u_pricing_mode
        }
      }
    }
  }
`;

export const GET_FAILED_TRANSFER_TICKETS = gql`
  query GetFailedTransferTickets(
    $pageSize: Int = 5000,
    $pageOffset: Int = 0,
    $search_event: String = "%",
    $search_client: String = "%",
    $order_by: [getmanageticket_order_by!]
  ) {
    filtermanagetickets(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:"ToBeVerified", day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_is_published:{_eq:false},
        tp_status:{_eq:"ToBeVerified"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
      limit: $pageSize
      offset: $pageOffset
      order_by: $order_by
    ) {
      e_name
      l_name
      e_date
      e_address
      tp_section
      tp_row
      tp_seat_no
      tp_status
      tp_list_price
      u_id
      u_first_name
      u_last_name
      e_id
      t_id
      tp_id
      u_full_name: full_name
      u_email_id
      u_original_email
      e_brand_name
      e_status
      e_time_zone
      e_date_time_zone
      tp_delist_requested_email
      tp_updated_at
      tp_is_support_vanderbilt_nil_fund
      u_pricing_mode
    }
    filtermanagetickets_aggregate(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:"ToBeVerified", day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_is_published:{_eq:false},
        tp_status:{_eq:"ToBeVerified"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

// Add these to your ./api/TicketsQuery.ts file

// MARK TICKETS AS SOLD
export const MARK_TICKETS_AS_SOLD = gql`
  mutation MarkTicketsAsSold($ticketPlacementIds: [String!]!) {
    markTicketsAsSold(ticketPlacementIds: $ticketPlacementIds) {
      message
      success
      failedIds
    }
  }
`;

export const DELIST_TICKETS = gql`
  mutation DelistTickets($ticketPlacementIds: [uuid!]!, $requestedEmailId: String!) {
    delistTickets(delistTicketsInput: { 
      ticketPlacementIds: $ticketPlacementIds, 
      requestedEmailId: $requestedEmailId 
    }) {
      message
    }
  }
`;

export const DELIST_TICKET_BY_ADMIN = gql`
mutation DelistTicketByAdmin ($ticketPlacementId: uuid!) {
  delistTicketByAdmin(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`;



// Matches Hasura action: editTicketPriceBySuperUser(editTicketPriceInput: EditTicketPriceInput!)
export const EDIT_TICKET_PRICE_BY_SUPER_USER = gql`
  mutation EditTicketPriceBySuperUser($tp_ids: [uuid!]!, $tp_list_price: Float!) {
    editTicketPriceBySuperUser(
      editTicketPriceInput: { ticketPlacementIds: $tp_ids, tp_list_price: $tp_list_price }
    ) {
      message
      requiresConfirmation
    }
  }
`;

// Alternative direct price update mutation
export const UPDATE_PRICE_DIRECT = gql`
  mutation UpdatePriceDirect($tp_ids: [uuid!]!, $tp_list_price: float8!) {
    update_ticket_placement(
      where: { tp_id: { _in: $tp_ids } }
      _set: { tp_list_price: $tp_list_price }
    ) {
      affected_rows
      returning {
        tp_id
        tp_list_price
      }
    }
  }
`;

export const GET_MARKETPLACES_FOR_TICKETS = gql`
  query GetMarketplacesForTickets {
    marketplaces(where: { active: { _eq: true } }, order_by: { name: asc }) {
      id
      name
      vl_fee_percentage
      active
    }
  }
`;

export const GET_USER_FEE_PERCENT_BY_ID = gql`
  query GetUserFeePercentById($u_id: uuid!) {
    user_by_pk(u_id: $u_id) {
      u_id
      u_fee_percentage
    }
  }
`;
// Add this to your TicketsQuery.ts file
export const GET_COUNTS_FOR_ALL_TABS = gql`
  query GetAllTabCounts(
    $search_event: String = "%"
    $search_client: String = "%"
    $startdate: timestamptz
    $enddate: timestamptz
    $leagueId: Int
    $pricingMode: String = "%"
    $userIds: [String!]
    $verificationCutoff: timestamptz!
  ) {
    # Verification count (ToBeVerified + Verified)
    verificationCount: ticket_placement_aggregate(
      where: {
        _and: [
          { tp_status: { _in: ["ToBeVerified", "Verified"] } }
          { e_date: { _gte: $verificationCutoff } }
          { e_name: { _ilike: $search_event } }
          { u_email_id: { _ilike: $search_client } }
          { e_date: { _gte: $startdate } }
          { e_date: { _lte: $enddate } }
          { l_id: { _eq: $leagueId } }
          { u_pricing_mode: { _ilike: $pricingMode } }
          { u_id: { _in: $userIds } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }

    # Listed count
    listedCount: filterlisttickets_aggregate(
      where: {
        e_name: { _ilike: $search_event }
        u_email_id: { _ilike: $search_client }
        e_date: { _gte: $startdate }
        e_date: { _lte: $enddate }
        l_id: { _eq: $leagueId }
        u_pricing_mode: { _ilike: $pricingMode }
        u_id: { _in: $userIds }
        tp_status: { _eq: "List" }
      }
    ) {
      aggregate {
        count
      }
    }

    # Sold count
    soldCount: FilterSoldTickets_aggregate(
      where: {
        e_name: { _ilike: $search_event }
        u_email_id: { _ilike: $search_client }
        e_date: { _gte: $startdate }
        e_date: { _lte: $enddate }
        l_id: { _eq: $leagueId }
        u_pricing_mode: { _ilike: $pricingMode }
        u_id: { _in: $userIds }
      }
    ) {
      aggregate {
        count
      }
    }

    # Delisted count
    delistedCount: filterreturntickets_aggregate(
      where: {
        e_name: { _ilike: $search_event }
        u_email_id: { _ilike: $search_client }
        e_date: { _gte: $startdate }
        e_date: { _lte: $enddate }
        l_id: { _eq: $leagueId }
        u_pricing_mode: { _ilike: $pricingMode }
        u_id: { _in: $userIds }
        tp_status: { _in: ["Delist", "DelistInProgress", "DelistRequested", "Return"] }
      }
    ) {
      aggregate {
        count
      }
    }

    # Unsold count
    unsoldCount: filterUnsoldTickets_aggregate(
      where: {
        e_name: { _ilike: $search_event }
        u_email_id: { _ilike: $search_client }
        e_date: { _gte: $startdate }
        e_date: { _lte: $enddate }
        l_id: { _eq: $leagueId }
        u_pricing_mode: { _ilike: $pricingMode }
        u_id: { _in: $userIds }
      }
    ) {
      aggregate {
        count
      }
    }

    # Listing Expired count
    listingExpiredCount: ticket_placement_aggregate(
      where: {
        _and: [
          { tp_status: { _eq: "Closed" } }
          { e_name: { _ilike: $search_event } }
          { u_email_id: { _ilike: $search_client } }
          { e_date: { _gte: $startdate } }
          { e_date: { _lte: $enddate } }
          { l_id: { _eq: $leagueId } }
          { u_pricing_mode: { _ilike: $pricingMode } }
          { u_id: { _in: $userIds } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;